/*
 * File: SelectInput.tsx
 * Author: Austin Robinson
 * Date Created: 10/18/2023
 * Copyright (c) DrivingDoc 2023
 */

import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import MenuItem, { MenuItemProps } from "@mui/material/MenuItem";
import { StandardTextFieldProps } from "@mui/material/TextField";

export interface SelectInputOption extends MenuItemProps {
    label: string;
    value: string | number;
}

interface PropTypes extends StandardTextFieldProps {
    name: string
    label: string
    options?: SelectInputOption[]
}

export default function SelectInput({ name, label, options, ...props }: PropTypes) {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <TextField
                    name={name}
                    label={label}
                    select
                    variant="standard"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    ref={field.ref}
                    value={field.value ?? ''}
                    onBlur={field.onBlur}
                    onChange={(event) => {
                        field.onChange(event.target.value);
                    }}
                    {...props}
                >
                    {options?.map(({ label, ...props }) => (
                        <MenuItem key={props.key ?? props.value} {...props}>
                            {label}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        />
    )
}